import { BackButton, SectionLabel, PullQuote } from "@/components/shared";
import { LeisureMark } from "@/components/marks";
import { images } from "@/lib/constants";

export function ArticlePage() {
  return (
    <div className="pt-40 pb-24 px-6 md:px-12 max-w-4xl mx-auto animate-in fade-in duration-700">
      <BackButton />
      <SectionLabel number="01" label="GEOLOGY & WELLNESS" color="#1D4C74" className="mb-8" />
      <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] uppercase mb-12">Thermal Mapping the Desert Fault Line.</h1>
      <div className="relative mb-16 overflow-hidden arch-crop h-[50vh] md:h-[70vh]">
        <img src={images.pool} alt="Mineral Water" className="w-full h-full object-cover text-transparent" />
      </div>
      <article className="prose prose-lg max-w-2xl mx-auto">
        <p className="tracking-widest uppercase text-xs leading-loose opacity-80 mb-8">
          <span className="float-left text-6xl font-serif leading-none pr-3 pt-1 text-[#1D4C74]">L</span>
          ife & Times is developing an immersive elemental wellness experience where guests are invited to engage directly with the Desert Hot Springs earth energy vortex. Situated at the convergence of five elemental forces.
        </p>
        <p className="tracking-widest uppercase text-xs leading-loose opacity-80 mb-8">
          This storied oasis has attracted seekers of rejuvenation for decades. Today, as the global wellness market accelerates and hot springs culture surges back into the spotlight, the city's rare geology stands ready to reclaim its place.
        </p>
        <PullQuote
          mark={<LeisureMark className="w-16 h-16 text-[#C06B5D]" />}
          quote="We do not manufacture energy; we provide the architecture to receive it."
        />
      </article>
    </div>
  );
}
